module.exports = __webpack_public_path__ + "img/IMG_2629_P_L_WoodMatted_MockedUp.bc0aa432.jpg";